"use strict";

(() => {
  const selectors = {
    back: "[data-fourth-level-back]",
    category: "[data-fourth-level-category]",
    menu: "[data-fourth-level-menu]",
    root: "[data-fourth-level-root]",
    trigger: "[data-fourth-level-trigger]",
    view: "[data-fourth-level-view]",
  };

  function reset(menu, restoreFocus = false) {
    const activeTrigger = menu.querySelector(
      `${selectors.trigger}[aria-expanded="true"]`,
    );

    menu.querySelector(selectors.root).hidden = false;

    for (const trigger of menu.querySelectorAll(selectors.trigger)) {
      trigger.setAttribute("aria-expanded", "false");
    }

    for (const view of menu.querySelectorAll(selectors.view)) {
      view.hidden = true;
    }

    if (restoreFocus && activeTrigger) {
      activeTrigger.focus();
    }
  }

  function open(trigger) {
    const menu = trigger.closest(selectors.menu);
    const view = document.getElementById(trigger.getAttribute("aria-controls"));

    if (!view || !menu.contains(view)) return;

    reset(menu);
    menu.querySelector(selectors.root).hidden = true;
    trigger.setAttribute("aria-expanded", "true");
    view.hidden = false;
    view.querySelector(selectors.back).focus();
  }

  function init(root = document) {
    for (const category of root.querySelectorAll(selectors.category)) {
      if (category.dataset.fourthLevelInitialized === "true") continue;

      category.dataset.fourthLevelInitialized = "true";
      category.addEventListener("mouseenter", () => {
        const menu = category.querySelector(selectors.menu);
        if (menu) reset(menu);
      });
    }
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(selectors.trigger);
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    const back = event.target.closest(selectors.back);
    if (back) {
      event.preventDefault();
      reset(back.closest(selectors.menu), true);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    const menu = event.target.closest(selectors.menu);
    if (menu && menu.querySelector(`${selectors.trigger}[aria-expanded="true"]`)) {
      event.preventDefault();
      reset(menu, true);
    }
  });

  document.addEventListener("shopify:section:load", (event) => init(event.target));

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }
})();
